import $ from "jquery";
import axios from "axios";

let notificationButton = document.querySelector(".notification-button.mobile");
let newNotificationBadge = notificationButton?.querySelector(
  "#new-notification-badge",
); // кружок для кнопки при новом уведомлении
let notificationBlockOpen = false; // статус открытия модалки
let lastNewNotificationsCount = 0; // кол-во новых уведомлений
const notificationBlock = document.querySelector(".notification-block");
const notificationBlockElements = document.querySelector(
  ".notification-block__elements",
); // список со всеми уведомлениями
const notificationBlockClose = document.querySelector(
  ".notification-block__close",
); // кнопка закрытия модалки на мобилке

// Типы уведомлений, от которых зависит иконка, которую мы применяем
const notificationTypes = [
  "person-dash", //yes
  "person-add", //yes
  "envelope", // yes
  "list-check", // yes
  "clock-history", //yes
  "check-circle", // yes
  "dash-circle", // yes
  "trophy", // yes
  "to-check", // yes
];

const overlay = $("#notification-overlay");

let userId = notificationButton?.dataset.userId;
let isShowNewNotificationBadge = false;

let notificationReadAll = document.querySelector("#notification-read-all"); // кнопка для прочтения всех уведомлений
let notificationDeleteAll = document.querySelector("#notification-delete-all"); // кнопка для удаления всех уведомлений
let deleteButtons = document.querySelectorAll("#delete-notification"); // кнопка для удаление одного уведомления
let notificationsLinks = document.querySelectorAll(
  "a.notification-block__element-title",
);

// отображать кружок на колокольчике, если есть непрочтенные уведомления
function showNewNotificationBadge(isShow) {
  if (isShow) {
    newNotificationBadge.classList.remove("hidden");
  } else {
    newNotificationBadge.classList.add("hidden");
  }
}

// создание элемента с уведомлением
function createNotificationElement(
  id,
  type,
  title,
  created_at,
  status,
  url,
  targetElement = notificationBlockElements,
) {
  status = Number(status);
  if (!isShowNewNotificationBadge) {
    if (status != 1) {
      showNewNotificationBadge(true);
      isShowNewNotificationBadge = true;
    }
  }

  // создаем сам элемент уведомления
  const notificationBlockElement = document.createElement("div");
  notificationBlockElement.classList.add(`notification-block__element`);
  if (status == 1) {
    notificationBlockElement.classList.add(`read`);
  }

  // создаем иконку
  const elementIcon = document.createElement("div");
  elementIcon.classList.add("notification-block__element-icon");
  // option 1. добавляем иконку уведомления
  const elementIconImage = document.createElement("img");
  elementIconImage.setAttribute(
    "src",
    `/img/icons/${notificationTypes[Number(type)]}.svg`,
  );
  elementIcon.appendChild(elementIconImage);

  // создание элемента, который содержит название и дату
  const elementTitleWithDate = document.createElement("div");
  elementTitleWithDate.classList.add(
    "notification-block__element-title-with-date",
  );

  // создание элемента, содержащего название уведомления
  const elementTitle = document.createElement("a");
  elementTitle.classList.add(`notification-block__element-title`);
  elementTitle.setAttribute("data-notification-id", id);
  if (url && url !== "") {
    elementTitle.setAttribute("href", url);
    elementTitle?.addEventListener("click", () => {
      axios
        .get(`/notifications/read/${id}`)
        .then((response) => {
          updateNotificationsList(userId);
        })
        .catch((e) => {
          console.error(`Error on reading all notifications: ${e}`);
        });
    });
  }
  elementTitle.innerText = title;

  // создаем элемент, содержащий дату
  const elementDate = document.createElement("div");
  elementDate.classList.add(`notification-block__element-date`);
  const notificationDate = new Date(created_at);
  const notificationDay =
    notificationDate.getDate() < 10
      ? `0${notificationDate.getDate()}`
      : notificationDate.getDate();
  const notificationMonth =
    notificationDate.getMonth() + 1 > 9
      ? notificationDate.getMonth() + 1
      : `0${notificationDate.getMonth() + 1}`;
  elementDate.innerText = `${notificationDay}.${notificationMonth}.${notificationDate.getFullYear()}`;

  // создаем элемент, который содержит кружок, показывающий непрочтенность уведомления
  const elementUnreadCircle = document.createElement("span");
  elementUnreadCircle.classList.add(
    "notification-block__element-date",
    "unread",
  );

  // соединяем блок, содержащий название и дату, а еще сюда нужно запихнуть кружок
  if (status != 1) {
    elementDate.appendChild(elementUnreadCircle); // кружок о непрочтении
  }
  elementTitleWithDate.appendChild(elementTitle);
  elementTitleWithDate.appendChild(elementDate);

  // создаем блок, содержащий кнопку для удаления уведомления
  const elementDeleteBlock = document.createElement("div");
  elementDeleteBlock.classList.add("notification-block__element-delete-button");

  // создаем кнопку удаления уведомления
  const elementDeleteButton = document.createElement("button");
  elementDeleteButton.setAttribute("type", "button");
  elementDeleteButton.classList.add("btn", "btn_outline");
  elementDeleteButton.setAttribute("id", "delete-notification");
  elementDeleteButton.setAttribute("data-notification-id", id);

  // добавляем крестик к кнопке удаления уведомления
  const elementDeleteButtonImage = document.createElement("img");
  elementDeleteButtonImage.setAttribute("src", "/img/icons/close.svg");

  elementDeleteButton.appendChild(elementDeleteButtonImage);

  // добавляем кнопку удаления в блок удаления
  elementDeleteBlock.appendChild(elementDeleteButton);

  // объединяем элементы в один блок
  notificationBlockElement.appendChild(elementIcon);
  notificationBlockElement.appendChild(elementTitleWithDate);
  notificationBlockElement.appendChild(elementDeleteBlock);

  // добавлем объединенные элементы в наш блок со списком уведомлений
  targetElement.appendChild(notificationBlockElement);
}

// Добавление уведомления о том, что новых уведомлений нет
function createEmptyNotificationMessage() {
  const emptyNotificationMessage = document.createElement("div");
  emptyNotificationMessage.classList.add("alert-on-empty-notifications");
  emptyNotificationMessage.innerText = "Новых уведомлений нет";

  notificationBlock.appendChild(emptyNotificationMessage);
}

function createNotificationsActionButtons() {
  if (document.querySelectorAll("#delete-notification").length <= 0) {
    if (!document.querySelector(".alert-on-empty-notifications")) {
      createEmptyNotificationMessage();
    }
  } else {
    if (document.querySelector(".alert-on-empty-notifications")) {
      notificationBlock.removeChild(
        document.querySelector(".alert-on-empty-notifications"),
      );
    }
    // создание кнопки, позволяющей прочитать все уведомления
    const readAllButton = document.createElement("button");
    readAllButton.setAttribute("type", "button");
    readAllButton.classList.add("notification-block__button");
    readAllButton.setAttribute("id", "notification-read-all");
    readAllButton.innerText = "Прочитать все";

    // создание кнопки, позволяющей удалить все уведомления
    const deleteAllButton = document.createElement("button");
    deleteAllButton.setAttribute("type", "button");
    deleteAllButton.classList.add(
      "notification-block__button",
      "notification-block__button_delete",
    );
    deleteAllButton.setAttribute("id", "notification-delete-all");
    deleteAllButton.innerText = "Удалить все";

    notificationBlock.appendChild(readAllButton);
    notificationBlock.appendChild(deleteAllButton);
  }
}

// позволяет обновить список уведомлений в хедере
// получаем из бекенда
function updateNotificationsList(userId) {
  axios
    .post("/notifications/get", {
      user_id: userId,
    })
    .then((response) => {
      // здесь создаем множество элементов
      let unreadNotifications = 0;
      if (typeof response.data == "string") {
        let str = response.data;
        if (str.startsWith('{"user_id"')) {
          str = str.replace("}", "|");
          str = str.split("|")[1];
        }
        response.data = JSON.parse(str);
      }

      const tempNotificationBlockElements = document.createElement("div");

      response?.data.forEach((d) => {
        if (Number(d.status) != 1 && lastNewNotificationsCount == 0) {
          unreadNotifications++;
        }
        // Удаляем домен из заголовка
        if (d.title.includes(" | КОНКУРСЫ.РФ")) {
          d.title = d.title.replace(" | КОНКУРСЫ.РФ", "");
        }
        createNotificationElement(
          d.id,
          d.type_id,
          d.title,
          d.created_at,
          d.status,
          d.url ?? "",
          tempNotificationBlockElements,
        );
      });

      // Обновляем DOM одним действием, чтобы список не моргал при перерисовке.
      notificationBlockElements.replaceChildren(
        ...tempNotificationBlockElements.childNodes,
      );

      document
        .querySelectorAll("button.notification-block__button")
        .forEach((button) => {
          button.remove();
        });

      const emptyNotificationMessage = document.querySelector(
        ".alert-on-empty-notifications",
      );
      if (emptyNotificationMessage) {
        emptyNotificationMessage.remove();
      }

      if (lastNewNotificationsCount == 0) {
        lastNewNotificationsCount = unreadNotifications;
      }
      createNotificationsActionButtons();
      initNotificationButtons();
    })
    .catch((e) => {
      console.error(`Error on getting notification list: ${e}`);
    });
}

function initTimeoutNotifications() {
  setInterval(() => {
    // Если вкладка не активна, то проверяем уведомления
    if (document.hidden) {
      return;
    }

    axios
      .get(`/notifications/check/${userId}`)
      .then((response) => {
        if (response.data != lastNewNotificationsCount) {
          lastNewNotificationsCount = response.data;
          updateNotificationsList(userId);
        } else if (response.data <= 0) {
          isShowNewNotificationBadge = false;
          showNewNotificationBadge(false);
        }
      })
      .catch((e) => {
        console.error(`Error on checking notifications: ${e}`);
      });
  }, 60000);
}

// функция для закрытия модалки
function closeHeaderNotificationsModal() {
  if (notificationBlockOpen) {
    notificationBlock.classList.add("hidden");
    notificationBlockClose.classList.add("hidden");
    overlay.fadeOut();
    notificationBlockOpen = false;
  }
}

// инициализируем все кнопки после каждого обновления
function initNotificationButtons() {
  if (!notificationButton) {
    return;
  }

  notificationReadAll = document.querySelector("#notification-read-all"); // кнопка для прочтения всех уведомлений
  notificationDeleteAll = document.querySelector("#notification-delete-all"); // кнопка для удаления всех уведомлений
  deleteButtons = document.querySelectorAll("#delete-notification"); // кнопка для удаление одного уведомления
  notificationsLinks = document.querySelectorAll(
    "a.notification-block__element-title",
  );

  userId = notificationButton.dataset.userId;

  if (notificationBlock.dataset.actionsBound === "1") {
    return;
  }

  // Делегирование кликов: кнопки пересоздаются при каждом обновлении списка.
  notificationBlock.addEventListener("click", (event) => {
    const eventTarget =
      event.target instanceof Element ? event.target : event.target?.parentElement;

    if (!eventTarget) {
      return;
    }

    const deleteNotificationButton = eventTarget.closest("#delete-notification");
    if (deleteNotificationButton) {
      event.preventDefault();
      event.stopPropagation();

      const notificationId = deleteNotificationButton.getAttribute(
        "data-notification-id",
      );

      axios
        .post(`/notifications/delete/${notificationId}`, {
          id: notificationId,
        })
        .then(() => {
          updateNotificationsList(userId);

          if (document.querySelectorAll("#delete-notification").length <= 0) {
            isShowNewNotificationBadge = false;
            showNewNotificationBadge(false);
          }
        })
        .catch((e) => {
          console.error(`Error on notification deleting: ${e}`);
        });

      return;
    }

    const readAllButton = eventTarget.closest("#notification-read-all");
    if (readAllButton) {
      event.preventDefault();
      event.stopPropagation();

      axios
        .get("/notifications/read")
        .then(() => {
          isShowNewNotificationBadge = false;
          showNewNotificationBadge(false);
          updateNotificationsList(userId);
          closeHeaderNotificationsModal();
        })
        .catch((e) => {
          console.error(`Error on reading all notifications: ${e}`);
        });

      return;
    }

    const deleteAllButton = eventTarget.closest("#notification-delete-all");
    if (deleteAllButton) {
      event.preventDefault();
      event.stopPropagation();

      axios
        .get("/notifications/delete")
        .then(() => {
          isShowNewNotificationBadge = false;
          showNewNotificationBadge(false);
          updateNotificationsList(userId);
        })
        .catch((e) => {
          console.error(`Error on deleting all notifications: ${e}`);
        });
    }
  });

  notificationBlock.dataset.actionsBound = "1";
}

export default function initNotifications() {
  if (!notificationButton) {
    return;
  }

  if (window.innerWidth > 768) {
    notificationButton = document.querySelector(".notification-button");
    newNotificationBadge = notificationButton.querySelector(
      "#new-notification-badge",
    ); // кружок для кнопки при новом уведомлении
  }

  // открытие блока со списком уведомлений
  notificationBlockOpen = false;
  notificationButton.addEventListener("click", () => {
    if (!notificationBlockOpen) {
      notificationBlock.classList.remove("hidden");
      if (window.innerWidth <= 768) {
        notificationBlockClose.classList.remove("hidden");
      }
      overlay.fadeIn();
      notificationBlockOpen = true;
    } else {
      notificationBlock.classList.add("hidden");
      if (window.innerWidth <= 768) {
        notificationBlockClose.classList.add("hidden");
      }
      overlay.fadeOut();
      notificationBlockOpen = false;
    }
  });

  if (window.innerWidth <= 768) {
    overlay.append($(".notification-block"));

    notificationBlockClose.addEventListener("click", () => {
      if (!notificationBlockOpen) {
        notificationBlock.classList.remove("hidden");
        notificationBlockClose.classList.remove("hidden");
        overlay.fadeIn();
        notificationBlockOpen = true;
      } else {
        notificationBlock.classList.add("hidden");
        notificationBlockClose.classList.add("hidden");
        overlay.fadeOut();
        notificationBlockOpen = false;
      }
    });
  }

  overlay.on("click", () => {
    notificationBlock.classList.add("hidden");
    overlay.fadeOut();
    notificationBlockOpen = false;
  });

  updateNotificationsList(userId);
  // проверка на наличие уведомлений каждые 30 секунд
  initTimeoutNotifications();
}
